// 1 Day = 24 Hrs = 24*60*60 = 86400.
export const ONE_DAY = 86400;
export const ONE_WEEK = ONE_DAY * 7;
export const TEN_DAYS = ONE_DAY * 10;
export const ONE_MONTH = ONE_WEEK * 4;

// We have to multiply by 1000 because these are ms
export const expiresOneMonth = () => new Date(Date.now() + ONE_MONTH * 1000);
export const expiresTenDays = () => new Date(Date.now() + ONE_DAY * 10 * 1000);

export const MIN_QUANTITY_AVAILABLE = 5;
